//
//
//
//

export default {
  name: 'alliance_map',
  data() {
    return {
      url: window.location.href,//当前地址
    }
  },
  created() {
     if(sessionStorage.getItem('token') == null){
      this.get_token(this.url);
     }
      this.get_conf();
  },
  methods: {
    get_token(url) {
      this.$EpetJs.Common.approve(url, function() {}); //生成token
    },
    get_conf() {
      var self = this;
      //微信js授权config
      this.$EpetJs.Common.get_conf(this.url, function (res) {
        self.$wx.config(res);
        self.$wx.error(function (res) {
          alert("出错了：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
        });
      });
      this.$wx.ready(function(){
          self.get_map();
    });
    },
    get_map() {
      var self = this;
      this.$wx.openLocation({
        // latitude:29.71798 , // 纬度，浮点数，范围为90 ~ -90
        // longitude: 106.63043, // 经度，浮点数，范围为180 ~ -180。
        latitude:Number(self.$route.query.shop_location_lat), // 纬度，浮点数，范围为90 ~ -90
        longitude:Number(self.$route.query.shop_location_lng), // 经度，浮点数，范围为180 ~ -180。
        name:self.$route.query.shop_name, // 位置名
        address:self.$route.query.shop_address, // 地址详情说明
        scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
      });
      self.$wx.error(function (res) {
        alert("出错：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
      });
    }
  }

}
